import { render, staticRenderFns } from "./ChainLink.vue?vue&type=template&id=2e2f8700&scoped=true&"
import script from "./ChainLink.vue?vue&type=script&lang=js&"
export * from "./ChainLink.vue?vue&type=script&lang=js&"
import style0 from "./ChainLink.vue?vue&type=style&index=0&id=2e2f8700&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2f8700",
  null
  
)

export default component.exports